import { Grid, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { ActionMenu } from '../../ui';
import { DateFormatter } from '../../util';
import { useStyles } from './Notifications';
import { useCreateActionItemFromNotificationMutation } from '@syncfab/machine';

interface NotificationRowProps {
  description: string;
  icon: JSX.Element;
  linkText: string;
  linkDestination: string;
  date: Date;
  notificationId: string;
  handleNotificationClick: (string) => Promise<void>;
  handleClose: () => void;
}
const NotificationRow: React.FC<NotificationRowProps> = ({
  description,
  icon,
  linkText,
  linkDestination,
  date,
  notificationId,
  handleNotificationClick,
  handleClose,
}) => {
  const classes = useStyles();
  const [createActionItem] = useCreateActionItemFromNotificationMutation();

  return (
    <Grid container direction="row">
      <Grid item xs={2}>
        {icon}
      </Grid>
      <Grid item xs={9} container direction="column">
        <Grid container>
          <Grid item xs={4}>
            <Link
              className={classes.link}
              to={`/${linkDestination}`}
              onClick={() => {
                handleClose();
              }}
            >
              {linkText}
            </Link>
            <Typography variant="body2">
              {DateFormatter.format(date)}
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <div>{description}</div>
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={1}>
        <ActionMenu
          itemKey={notificationId}
          handleMenuOptionClick={async (option, key) => {
            if (option === 'Mark as Viewed') {
              await handleNotificationClick(key);
            } else if (option === 'Create Action Item') {
              await createActionItem(notificationId);
            }
          }}
          menuOptions={['Create Action Item', 'Mark as Viewed']}
        />
      </Grid>
    </Grid>
  );
};

export default NotificationRow;
